export const USERS_UPDATE_LOADING = 'USERS_UPDATE_LOADING';
export const USERS_UPDATE_SUCCESS = 'USERS_UPDATE_SUCCESS';
export const USERS_UPDATE_ERROR = 'USERS_UPDATE_ERROR';
export const USERS_UPDATE_RESET = 'USERS_UPDATE_RESET';

const initialState = {
    success: null,
    loading: false,
    error: null,
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case USERS_UPDATE_LOADING:
            return {
                success: null,
                loading: true,
                error: null,
            };
        case USERS_UPDATE_SUCCESS:
            return {
                success: true,
                loading: false,
                error: null,
            };
        case USERS_UPDATE_ERROR:
            return {
                success: false,
                loading: false,
                error: action.payload,
            };
        case USERS_UPDATE_RESET:
            return initialState;
        default:
            return state;
    }
}

const storeName = "usersUpdate";

const storeMapping = {[storeName]: reducer};

export const usersUpdateSelector = (state) => state[storeName];

export default storeMapping;
